import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import Table from "../../NewTable";
import ApprovalModal from "../../RequestActionModal";
import useIsAr from "../../../Hooks/useIsAr";
import Modal from "../../Modal";
import KPIHistory from "./History";
import { ReactComponent as ApproveIcon } from "../../../assets/images/correct.svg";
import { ReactComponent as RejectIcon } from "../../../assets/images/close.svg";
import { formatDate, getStatusKPIName } from "../../../helpers";
import "./style.scss";

const initialModal = {
  isOpen: false,
  data: null,
};

function KPIHistoryNavigater({ requests, KPIDetails, getData }) {
  const [isAr, locale] = useIsAr();
  const requestStatuses = useSelector(
    ({ theme }) => theme.WorkflowStatus.item.Items
  );
  const [componentIndex, setComponentIndex] = useState(0);
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [measureItem, setMeasureItem] = useState({});
  const [isApprove, setIsApprove] = useState(false);

  const isPercent = KPIDetails.UnitOfMeasure === "Percentage";
  const suffix = isPercent
    ? "%"
    : isAr
    ? KPIDetails.ArabicUnitDetails
    : KPIDetails.EnglishUnitDetails;

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      key: "due-date",
      header: <FormattedMessage id="common.due-date" />,
      cell: (item) =>
        item.Form?.DueDate ? formatDate(item.Form.DueDate) : "---",
      width: "15%",
    },
    {
      key: "target",
      header: <FormattedMessage id="kpi-list.target" />,
      cell: (item) =>
        item.Form?.Target
          ? `${item.Form?.Target}${
              item.Form?.MaxTarget ? " -" + item.Form?.MaxTarget : ""
            } ${suffix}`
          : "---",
      width: "20%",
    },
    {
      key: "new-value",
      header: <FormattedMessage id="project-details-tap.new-value" />,
      cell: (item) =>
        item.Form?.IsSkipped ? "---" : `${item.Form?.Value} ${suffix}`,
      width: "20%",
    },
    {
      key: "lastUpdate",
      header: <FormattedMessage id="dashboard.lastUpdate" />,
      cell: (item) => (item.Modified ? formatDate(item.Modified) : "---"),
      width: "15%",
    },
    {
      key: "status",
      header: <FormattedMessage id="common.status" />,
      cell: (item) =>
        getStatusKPIName(requestStatuses, item.Status?.toString(), locale),
      width: "20%",
    },
  ];

  const actions = [
    {
      variant: "success",
      shape: "square",
      Icon: ApproveIcon,
      hidden: (item) => !item?.CanApprove,
      onClick: (item) => {
        setOpenApproveModal(true);
        setMeasureItem(item);
        setIsApprove(true);
      },
    },
    {
      variant: "error",
      shape: "square",
      hidden: (item) => !item?.CanApprove,
      Icon: RejectIcon,
      onClick: (item) => {
        setOpenApproveModal(true);
        setMeasureItem(item);
        setIsApprove(false);
      },
    },
  ];

  const componentsList = [
    {
      name: "history",
      component: (
        <div className="history-table" style={{ margin: "0 32px" }}>
          <Table
            columns={columns}
            data={requests}
            actions={actions}
            actionsHeader={<FormattedMessage id="common.action" />}
            onClickItem={(item) => {
              setComponentIndex(1);
              setMeasureItem(item);
            }}
          />
        </div>
      ),
    },
    {
      name: "history",
      component: (
        <KPIHistory
          measureItem={measureItem}
          data={requests}
          locale={locale}
          onBack={() => setComponentIndex(0)}
        />
      ),
    },
  ];

  return (
    <>
      {componentsList[componentIndex].component}
      {openApproveModal ? (
        <Modal isOpen={openApproveModal}>
          <ApprovalModal
            measureItem={measureItem}
            locale={locale}
            callback={() => getData()}
            closeModal={() => setOpenApproveModal(false)}
            isApprove={isApprove}
          />
        </Modal>
      ) : null}
    </>
  );
}

export default KPIHistoryNavigater;
